import Icon from "../Icon";
import { CSSProperties } from "react";

type CockpitYoutubePlayerProps = {
  id?: string;
  className?: string;
  style?: CSSProperties;
  title?: string;
  videoId: string;
  fullScreen?: boolean;
};

function CockpitYoutubePlayer({
  id,
  className,
  style,
  videoId,
  title,
  fullScreen
}: CockpitYoutubePlayerProps) {
  if (videoId) {
    const src = new URL(`https://www.youtube.com/embed/${videoId}`);
    const videoParams = new URLSearchParams(src.search);
    src.search = `modestbranding=1&showinfo=0&rel=0&theme=light&fs=${
      fullScreen ? "1" : "0"
    }&color=white`;
    videoParams.forEach((value, name) => {
      src.searchParams.append(name, value);
    });
    return (
      <div id={id} className={className} style={{ ...style }}>
        <iframe
          width="100%"
          style={{ aspectRatio: "16/9", ...style }}
          src={src.toString()}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>
    );
  } else {
    return (
      <div className="empty-msg">
        <div>
          <Icon name="face-sad-tear" size="4x" />
        </div>
        <div>Missing videoId</div>
      </div>
    );
  }
}

export default CockpitYoutubePlayer;
